// extracted by mini-css-extract-plugin
export var textInput = "_fh-0";